/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.StorefrontTools || (M.Template.StorefrontTools = {});

M.Template.StorefrontTools.AllProducts = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<div class="bm">\n  <span>Star 3 products to feature them in your store.</span>\n  <a class="button buttonFlat buttonMedium buttonPrimary floatR bm saveChoices">\n    save\n  </a>\n</div>\n<div class="box boxOptions activeProducts bm">\n  <div class="heading">\n    <p>\n      <h2 style=\'display:inline-block\'>all products\n      <span class="largeBodyText">\n        '+
((__t=( M.html.htmlAttributeEscape(allItemsCount) ))==null?'':__t)+
' items\n      </span>\n    </h2>\n    </p>\n    <form class="floatR" action="/search" method="get">\n      <img class="searchIcon"\n        src="'+
((__t=( M.img_src("/static/images/sprite_placeholder.png") ))==null?'':__t)+
'" />\n      <input class="searchField" type="text" name="s"\n        placeholder="Search a product..."\n\n        />\n    </form>\n  </div>\n\n  <table class="report storefrontProducts">\n    <thead>\n      <tr>\n        ';
 // data-attr should always be the sort name 
__p+='\n        <th class="featured" data-attr="isFeatured">Featured?</th>\n        <th class="productName" data-attr="name">Product</th>\n        <th class="productKind" data-attr="productKindName">Category</th>\n        <th class="winning" data-attr="isWinner">Winning</th>\n      </tr>\n    </thead>\n    <tbody class="visibleProducts"></tbody>\n   </table>\n</div>';
}
return __p;
});

M.Template.StorefrontTools.DesignerAssetUpload = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014, 2016 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:IDENTITY
   */
__p+='\n\n';
 if (options.using_welcome_mode ) { 
__p+='\n  <div class="alert clearB welcomeHeader">\n    <h2 class="welcomeHeaderIntro">congratulations on your new store!</h2>\n    <h3>\n      You\'re almost ready to open your Minted store. To create an\n      engaging and personalized experience, please upload the visual\n      assets listed below. <a target="_blank" href="/store/melanieseverin">\n      See an example</a>.\n    </h3>\n  </div>\n  <br>\n';
 } else { 
__p+='\n  <h2 class="separator separatorDotted">\n    add missing images to your store\n  </h2>\n';
 } 
__p+='\n\n';
 if (options.show_all_assets) { 
__p+='\n<div class="missingAssetBlock separator separatorDotted">\n  <div style="height:100px;">\n    <div class="missingAssetInput floatL">\n      <div>\n        <h4 class="missingAssetInputTitle">Your City</h4>\n      </div>\n      <div class="clearB bm5">\n        <input id="designerLocation" class="assetTextArea"\n          name="location" style="width:316px"\n          value="'+
((__t=(M.html.htmlAttributeEscape(options.designer.location)))==null?'':__t)+
'">\n      </div>\n      <div>\n        <a class="button buttonSmall buttonPrimary buttonFlat clearB\n                 submitTextButton tc" style="display:none; width:120px">\n         save changes\n        </a>\n      </div>\n      <div class="submitMsg warning"></div>\n    </div>\n    <div class="missingAssetHelpTextMain floatR"\n       style="position:relative;">\n      <div class="box boxSimple floatL"\n         style="position:absolute; top:30%;">\n          <div style="margin-bottom:5px;">\n            <span style="font-weight:bold;">\n              Tell everyone where you are from.\n            </span>\n          </div>\n          <div class="clearB">\n            This will appear on your Store. Start typing your city name, and\n            select your location from the available options.\n          </div>\n        </div>\n      </div>\n    </div>\n</div>\n<div class="missingAssetBlock separator separatorDotted">\n  <div style="height:100px;">\n    <div class="missingAssetInput floatL">\n      <div>\n        <h4 class="missingAssetInputTitle">Your Personal Website</h4>\n      </div>\n      <div class="clearB bm5">\n        <input id="personalUrl" class="assetTextArea"\n          name="personalUrl" style="width:316px"\n          value="'+
((__t=(M.html.htmlAttributeEscape(options.designer.personal_url)))==null?'':__t)+
'">\n      </div>\n      <div>\n        <a class="button buttonSmall buttonPrimary buttonFlat clearB\n                 submitTextButton tc" style="display:none; width:120px">\n         save changes\n        </a>\n      </div>\n      <div class="submitMsg warning"></div>\n    </div>\n    <div class="missingAssetHelpTextMain floatR"\n       style="position:relative;">\n      <div class="box boxSimple floatL"\n         style="position:absolute; top:30%;">\n          <div style="margin-bottom:5px;">\n            <span style="font-weight:bold;">\n              Link everyone to your personal website.\n            </span>\n          </div>\n          <div class="clearB">\n            Add your own personal commerce site, blog, Facebook, or social\n            media site. Links to competitor sites are not permitted (e.g. Etsy).\n          </div>\n        </div>\n      </div>\n    </div>\n</div>\n<div class="missingAssetBlock separator separatorDotted">\n  <div style="height:100px;">\n    <div class="missingAssetInput floatL">\n      <div>\n        <h4 class="missingAssetInputTitle">About Yourself</h4>\n      </div>\n      <div class="clearB">\n       <textarea rows="5" cols="50"\n         name="philosophy"\n         class="assetTextArea bm10">'+
((__t=(M.html.htmlAttributeEscape(options.designer.philosophy)))==null?'':__t)+
'</textarea>\n        <div>\n          <a class="button buttonSmall buttonPrimary buttonFlat clearB\n                   submitTextButton tc" style="display:none; width:120px">\n           save changes\n          </a>\n        </div>\n        <div class="submitMsg warning"></div>\n      </div>\n    </div>\n    <div class="missingAssetHelpTextMain floatR"\n       style="position:relative;">\n      <div class="box boxSimple floatL"\n         style="position:absolute; top:30%;">\n          <div style="margin-bottom:5px;">\n            <span style="font-weight:bold;">\n              Tell everyone about yourself.\n            </span>\n          </div>\n          <div class="clearB">\n            This will appear on your store and on your profile.\n            It should be 500 characters or less.\n          </div>\n        </div>\n      </div>\n    </div>\n</div>\n';
 } 
__p+='\n\n';
 if (options.show_all_assets || !options.profile_img_url) { 
__p+='\n<div class="missingAssetBlock separator separatorDotted">\n  <div style="height:230px;">\n    <div class="missingAssetInput floatL">\n      <div>\n        <h4 class="missingAssetInputTitle">Your Photo</h4>\n      </div>\n      <div class="clearB">\n        <div class="editableImageSimple">\n          ';
 if (options.profile_img_url) { 
__p+='\n            profile_img,200,200,200,200,'+
((__t=(M.html.htmlAttributeEscape(options.profile_img_url) ))==null?'':__t)+
'\n          ';
 } else { 
__p+='\n            profile_img,200,200,200,200\n          ';
 } 
__p+='\n        </div>\n      </div>\n    </div>\n    <div class="missingAssetHelpTextMain floatR" style="position:relative;">\n      <div class="box boxSimple floatL"\n         style="position:absolute; top:30%;">\n        <div style="margin-bottom:5px;">\n         <span style="font-weight:bold;">\n           Upload a JPEG, GIF, or PNG, that is at least 200px x 200px\n           square.\n         </span>\n        </div>\n        <div class="clearB">\n         This should be a photo of your face, not a logo. This will\n         appear next to your name throughout the website. It will\n         also be featured on your store.\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n';
 } 
__p+='\n\n';
 if (options.show_all_assets || !options.storefront_banner_img_url) { 
__p+='\n<div class="missingAssetBlock separator separatorDotted">\n <div style="height:150px;">\n   <div class="missingAssetInput floatL">\n     <div>\n       <h4 class="missingAssetInputTitle">\n         Cover Image for your Store\n       </h4>\n     </div>\n     <div class="clearB">\n        <div class="editableImageSimple">\n          ';
 if (options.storefront_banner_img_url) { 
__p+='\n            storefront_banner_img,105, 480, 420, 1920,'+
((__t=(M.html.htmlAttributeEscape(options.storefront_banner_img_url) ))==null?'':__t)+
'\n          ';
 } else { 
__p+='\n            storefront_banner_img,105, 480, 420, 1920\n          ';
 } 
__p+='\n       </div>\n     </div>\n   </div>\n   <div class="missingAssetHelpTextMain floatR" style="position:relative;">\n     <div class="box boxSimple floatL"\n         style="position:absolute; top:0%;">\n       <div style="margin-bottom:5px;">\n         <span style="font-weight:bold;">\n           Upload a JPEG, GIF, or PNG that\'s 1920px x 420px.\n         </span>\n       </div>\n       <div class="clearB">\n         This photo will appear at the top of your store, which\n         appears when customers click on your name. Please upload\n         a "cover photo" that reveals your workplace, tools, or a\n         detail or pattern from your work. We\'ll apply a\n         transparent overlay on top of your image to ensure\n         legibility of your hand-written name and information.\n       </div>\n     </div>\n   </div>\n </div>\n</div>\n';
 } 
__p+='\n\n';
 if (options.should_show_artist_only_assets) { 
__p+='\n  ';
 if (options.show_all_assets || !options.signature_img_url_white) { 
__p+='\n  <div class="missingAssetBlock separator separatorDotted">\n   <div style="height:120px;">\n     <div class="missingAssetInput floatL">\n       <div>\n         <h4 class="missingAssetInputTitle">\n           Hand-written Name: White\n         </h4>\n       </div>\n       <div class="clearB">\n         <div class="editableImageSimple">\n          ';
 if (options.signature_img_url_white) { 
__p+='\n            signature_img_white,80, 300, 160, 600, '+
((__t=(M.html.htmlAttributeEscape(options.signature_img_url_white) ))==null?'':__t)+
'\n          ';
 } else { 
__p+='\n            signature_img_white,80, 300, 160, 600\n          ';
 } 
__p+='\n         </div>\n       </div>\n     </div>\n     <div class="missingAssetHelpTextMain floatR" style="position:relative;">\n       <div class="box boxSimple floatL"\n           style="position:absolute; top:10%;">\n         <div style="margin-bottom:5px;">\n           <span style="font-weight:bold;">\n             Upload a transparent PNG that\'s 600px x 160px.\n           </span>\n         </div>\n         <div class="clearB">\n           Please upload a white version of your hand-written\n           name. The background should be 100% transparent.\n           See <a href="https://minteddesign.zendesk.com/hc/en-us/articles/115003617503-What-is-the-hand-written-name-and-how-do-I-prepare-it-"\n             target="_blank">here</a> for more information on\n           preparing the file.\n         </div>\n       </div>\n     </div>\n   </div>\n  </div>\n  ';
 } 
__p+='\n\n  ';
 if (options.show_all_assets || !options.signature_img_url_black) { 
__p+='\n  <div class="missingAssetBlock separator separatorDotted" style="position:relative;">\n   <div style="height:160px;">\n     <div class="missingAssetInput floatL">\n       <div>\n         <h4 class="missingAssetInputTitle">\n           Hand-written Name: Black\n         </h4>\n       </div>\n       <div class="clearB">\n         <div class="editableImageSimple">\n           ';
 if (options.signature_img_url_black) { 
__p+='\n              signature_img_black,80, 300, 120, 415, '+
((__t=(M.html.htmlAttributeEscape(options.signature_img_url_black) ))==null?'':__t)+
'\n           ';
 } else { 
__p+='\n              signature_img_black,80, 300, 120, 415\n          ';
 } 
__p+='\n         </div>\n       </div>\n     </div>\n     <div class="missingAssetHelpTextMain floatR"\n         style="position:relative;">\n       <div class="box boxSimple floatL"\n           style="position:absolute; top:5%;">\n         <div style="margin-bottom:5px;">\n           <span style="font-weight:bold;">\n             Upload a transparent PNG that\'s 415px x 120px.\n           </span>\n         </div>\n         <div class="clearB">\n           Upload a hand-written image of your full name (first and\n           last) on a 100% transparent background. This image will\n           appear on the certificate of authenticity for art prints, on the\n           packing slip included in customer orders, and in other locations.\n           Your hand-written name will express your identity and should not\n           use fonts or logos, but can definitely incorporate whimsy.\n           See <a href="https://minteddesign.zendesk.com/hc/en-us/articles/115003617503-What-is-the-hand-written-name-and-how-do-I-prepare-it-"\n             target="_blank">here</a> for more information on\n           preparing the file and view some examples.\n         </div>\n       </div>\n     </div>\n   </div>\n  </div>\n  ';
 } 
__p+='\n\n  ';
 if (options.show_all_assets || !options.signature_img_url_artist) { 
__p+='\n  <div class="missingAssetBlock separator separatorDotted" style="position:relative;">\n   <div style="height:260px;">\n     <div class="missingAssetInput floatL">\n       <div>\n         <h4 class="missingAssetInputTitle">\n           Art Print Signature\n         </h4>\n       </div>\n       <div class="clearB">\n         <div class="editableImageSimple">\n           ';
 if (options.signature_img_url_artist) { 
__p+='\n              signature_img_artist, 80, 300, 120, 415, '+
((__t=(M.html.htmlAttributeEscape(options.signature_img_url_artist) ))==null?'':__t)+
'\n           ';
 } else { 
__p+='\n              signature_img_artist, 80, 300, 120, 415\n          ';
 } 
__p+='\n         </div>\n       </div>\n     </div>\n     <div class="missingAssetHelpTextMain floatR"\n         style="position:relative;">\n       <div class="box boxSimple floatL"\n           style="position:absolute; top:5%;">\n         <div style="margin-bottom:5px;">\n           <span style="font-weight:bold;">\n             Upload a transparent PNG that\'s 415px x 120px.\n           </span>\n         </div>\n         <div class="clearB">\n          This should be the signature you would like to have appear on your\n          art prints, which will be signed (using a signature machine) in\n          pencil in the right hand corner of all limited edition prints. Your\n          artist signature will communicate your identity as a serious artist\n          and should not use fonts or logos. This is a highly requested\n          feature from our customers, who believe that artist signatures\n          increase the value of the print. However, customers can opt-out\n          during purchase if they do not want a signature on their print.\n          <b>Please note that your artist signature can only be uploaded once and,\n          once uploaded, <u class="warning">cannot be changed or modified</u>.</b>\n          <b>If we do not have your Art Print Signature on file, we are unable to\n          launch any of your Challenge-winning art pieces.</b>\n          See <a href="https://minteddesign.zendesk.com/hc/en-us/articles/10840872696077-Creating-your-Artist-Signature"\n            target="_blank">here</a> for more information on preparing the\n          file and a sample image of how this will appear.\n         </div>\n       </div>\n     </div>\n   </div>\n  </div>\n  ';
 } 
__p+='\n';
 } 
__p+='\n\n';
 if (options.show_all_assets || !options.has_all_about_artist_photos) { 
__p+='\n  <div class="missingAssetBlock separator separatorDotted" style="position:relative;">\n   <div style="height:260px;">\n     <div class="missingAssetInput floatL">\n       <div>\n         <h4 class="missingAssetInputTitle">\n           About Yourself - Photo 1\n         </h4>\n       </div>\n       <div class="clearB">\n         <div class="editableImageSimple">\n           ';
 if (options.about_artist_photo_1_img_url) { 
__p+='\n              about-artist-photo-1, 160, 355, 640, 1420, '+
((__t=(M.html.htmlAttributeEscape(options.about_artist_photo_1_img_url) ))==null?'':__t)+
'\n           ';
 } else { 
__p+='\n              about-artist-photo-1, 160, 355, 640, 1420\n          ';
 } 
__p+='\n         </div>\n       </div>\n       <br><br>\n       <div>\n         <h4 class="missingAssetInputTitle">\n           About Yourself - Photo 2\n         </h4>\n       </div>\n       <div class="clearB">\n         <div class="editableImageSimple">\n           ';
 if (options.about_artist_photo_2_img_url) { 
__p+='\n              about-artist-photo-2, 160, 355, 640, 1420, '+
((__t=(M.html.htmlAttributeEscape(options.about_artist_photo_2_img_url) ))==null?'':__t)+
'\n           ';
 } else { 
__p+='\n              about-artist-photo-2, 160, 355, 640, 1420\n          ';
 } 
__p+='\n         </div>\n       </div>\n       <br><br>\n       <div>\n         <h4 class="missingAssetInputTitle">\n           About Yourself - Photo 3\n         </h4>\n       </div>\n       <div class="clearB">\n         <div class="editableImageSimple">\n           ';
 if (options.about_artist_photo_3_img_url) { 
__p+='\n              about-artist-photo-3, 160, 355, 640, 1420, '+
((__t=(M.html.htmlAttributeEscape(options.about_artist_photo_3_img_url) ))==null?'':__t)+
'\n           ';
 } else { 
__p+='\n              about-artist-photo-3, 160, 355, 640, 1420\n          ';
 } 
__p+='\n         </div>\n       </div>\n       <br><br>\n       <div>\n         <h4 class="missingAssetInputTitle">\n           About Yourself - Photo 4\n         </h4>\n       </div>\n       <div class="clearB">\n         <div class="editableImageSimple">\n           ';
 if (options.about_artist_photo_4_img_url) { 
__p+='\n              about-artist-photo-4, 160, 355, 640, 1420, '+
((__t=(M.html.htmlAttributeEscape(options.about_artist_photo_4_img_url) ))==null?'':__t)+
'\n           ';
 } else { 
__p+='\n              about-artist-photo-4, 160, 355, 640, 1420\n          ';
 } 
__p+='\n         </div>\n       </div>\n       <br><br>\n       <div>\n         <h4 class="missingAssetInputTitle">\n           About Yourself - Photo 5\n         </h4>\n       </div>\n       <div class="clearB">\n         <div class="editableImageSimple">\n           ';
 if (options.about_artist_photo_5_img_url) { 
__p+='\n              about-artist-photo-5, 160, 355, 640, 1420, '+
((__t=(M.html.htmlAttributeEscape(options.about_artist_photo_5_img_url) ))==null?'':__t)+
'\n           ';
 } else { 
__p+='\n              about-artist-photo-5, 160, 355, 640, 1420\n          ';
 } 
__p+='\n         </div>\n       </div>\n     </div>\n     <div class="missingAssetHelpTextMain floatR"\n         style="position:relative;">\n       <div class="box boxSimple floatL"\n           style="position:absolute; top:5%;">\n         <div style="margin-bottom:5px;">\n           <span style="font-weight:bold;">\n            Upload JPEGs, GIFs, or PNGs files that are 1420px x 640px.\n           </span>\n         </div>\n         <div class="clearB">\n          Add up to 5 photos that will appear in your store\'s\n          About You section in a rotating carousel.\n          Images will display in the sequence that they appear here\n          (the first photo will appear upon load of the page, the second photo will appear\n          next, etc.) We suggest you use these photos to give customers a behind-the-scenes look at your work space, a look at the tools and supplies you use, or a work in progress — something that tells your story.\n         </div>\n       </div>\n     </div>\n   </div>\n  </div>\n';
 } 
__p+='\n\n\n<div class="floatR clearB" style="padding-right:20px;">\n  <ul class="inline buttons">\n    ';
 if (!options.using_welcome_mode) { 
__p+='\n    <li>\n      <a class="button buttonFlat buttonMedium buttonSecondary\n          remindMeLaterButton">\n        remind me later\n      </a>\n    </li>\n    ';
 } 
__p+='\n    ';
 if (options.using_welcome_mode) { 
__p+='\n    <li>\n      <a class="button buttonFlat buttonMedium buttonSecondary"\n          href="'+
((__t=( M.html.htmlAttributeEscape(options.store_url) ))==null?'':__t)+
'" >\n        see my store\n      </a>\n    </li>\n      ';
 if (options.should_show_artist_only_assets) { 
__p+='\n      <li>\n        <a class="button buttonFlat buttonMedium buttonPrimary"\n            href="/production/selflaunch/product/choice">\n          launch a new product\n        </a>\n      </li>\n      ';
 } 
__p+='\n    ';
 } else if (options.is_store_tools) { 
__p+='\n    <li>\n      <a class="button buttonFlat buttonMedium buttonPrimary\n         doneButton">\n       done\n      </a>\n    </li>\n    ';
 } else { 
__p+='\n      <li>\n        <a class="button buttonFlat buttonMedium buttonPrimary disabled\n           doneButton">\n         done\n        </a>\n      </li>\n    ';
 } 
__p+='\n  </ul>\n</div>\n';
}
return __p;
});

M.Template.StorefrontTools.FeaturedAllRegion = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<h2>home page: region 3</h2>\n<div>\nSort your other items into the sequence of your choice below. They will be displayed in the bottom region of your shop home page\n</div>\n<div class="box boxOptions activeProducts bm">\n  <table class="report storefrontProducts">\n    <thead>\n      <tr>\n        <th>POS.</th>\n        <th>Product</th>\n        <th>Shop Section</th>\n        <th>Options</th>\n      </tr>\n    </thead>\n    <tbody class="sectionProducts"></tbody>\n   </table>\n</div>\n';
}
return __p;
});

M.Template.StorefrontTools.FeaturedProductDetails = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n<td>\n  <input type="checkbox" '+
((__t=( product.isInSection(section) ? 'checked' : '' ))==null?'':__t)+
' />\n</td>\n<td>\n  <div class="media avatar">\n    <a class="img">\n      <img src="'+
((__t=(product.getImgUrl()))==null?'':__t)+
'" />\n    </a>\n    <p class="floatL largeBodyText">\n      <a>'+
((__t=( M.html.htmlAttributeEscape(product.get('name')) ))==null?'':__t)+
'</a><br />\n      '+
((__t=( M.html.htmlAttributeEscape(product.get('productKindName')) ))==null?'':__t)+
'\n    </p>\n  </div>\n</td>';
}
return __p;
});

M.Template.StorefrontTools.FeaturedProducts = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n<td>\n  <div class="avatar product productCenter">\n    <a class="img">\n      <img src="'+
((__t=(this.getImgUrl()))==null?'':__t)+
'" />\n    </a>\n    <div>\n      <p class="tc largeBodyText">\n        <a>'+
((__t=( M.html.htmlAttributeEscape(this.get('name')) ))==null?'':__t)+
'</a><br />\n        '+
((__t=( M.html.htmlAttributeEscape(this.get('productKindName')) ))==null?'':__t)+
'<br />\n        <a>move left</a>&nbsp;&nbsp;|&nbsp;\n        <a>move right</a>\n      </p>\n    </div>\n  </div>\n</td>';
}
return __p;
});

M.Template.StorefrontTools.FeaturedRegions = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n<h2>home page: '+
((__t=( featuredTitle ))==null?'':__t)+
'</h2>\n\n<div class="box boxOptions activeProducts bm">\n  <h3 class="nm standardColor">FEATURED PRODUCTS</h3>\n  <table class="report storefrontProducts">\n    <tbody>\n      <tr>\n        ';
 _.each(storefrontProducts.models, function(storefrontProduct) { 
__p+='\n            '+
((__t=( M.Template.StorefrontTools.FeaturedProducts.apply(
                  storefrontProduct.getProduct(), arguments) ))==null?'':__t)+
'\n        ';
 }); 
__p+='\n      </tr>\n    </tbody>\n   </table>\n</div>\n<div class="box boxOptions hiddenProducts">\n  <table class="report storefrontProducts">\n    <thead>\n      <tr>\n        <th>Featured?</th>\n        <th>Product</th>\n      </tr>\n    </thead>\n    <tbody>\n      ';
 _.each(products, function(product) { 
__p+='\n        <tr>\n          '+
((__t=( M.Template.StorefrontTools.FeaturedProductDetails({ product: product, section: section }) ))==null?'':__t)+
'\n        </tr>\n      ';
 }); 
__p+='\n    </tbody>\n   </table>\n</div>';
}
return __p;
});

M.Template.StorefrontTools.GridSectionDescriptionDetails = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="gridSectionDescriptionDetailsContainer">\n  <div class="sectionDetailsInputContainer  ">\n    <div class="sectionTitle">\n      <h4>title</h4>\n      <div class="sectionNameContainer"></div>\n    </div>\n    <div class="sectionDescription">\n      <h4>description</h4>\n      <div class="sectionDescContainer"></div>\n    </div>\n  </div>\n</div>\n';
}
return __p;
});

M.Template.StorefrontTools.Header = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   *
   */
__p+='\n\n<div class="profilePictureContainer floatL">\n  <div class="profilePicture">\n    <img class="profilePictureImg"\n      src="'+
((__t=( M.html.htmlAttributeEscape(profileImgUrl) ))==null?'':__t)+
'" />\n  </div>\n</div>\n\n<div class="headerPageNavigationContainer large-8 floatL">\n  <div class="headerPageNavigation">\n    <h1 class="headerPageNavigationTitle">manage your store</h1>\n    <div class="headerPageNavigationLinks"></div>\n  </div>\n</div>';
}
return __p;
});

M.Template.StorefrontTools.InputText = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n<h4 class="subHeader">\n  '+
((__t=( M.html.htmlAttributeEscape(subHeader) ))==null?'':__t)+
'\n</h4>\n<input type="text" value="'+
((__t=( M.html.htmlAttributeEscape(inputValue) ))==null?'':__t)+
'"\nname="'+
((__t=( M.html.htmlAttributeEscape(inputName) ))==null?'':__t)+
'"\nmaxlength="'+
((__t=( M.html.htmlAttributeEscape(maxLength) ))==null?'':__t)+
'"/>\n<p class="inputValidationCaption">\n  '+
((__t=( M.html.htmlAttributeEscape(caption) ))==null?'':__t)+
'\n</p>\n';
}
return __p;
});

M.Template.StorefrontTools.Main = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   *
   */
__p+='\n\n<div class"storefrontToolsMain">\n  <div class="storefrontToolsHeader">\n  </div>\n</div>';
}
return __p;
});

M.Template.StorefrontTools.Navigation = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="separator">\n  <ul class="subNav subNavInline brandonNav floatL">\n    <li class="floatL"><a href="assets">ASSETS</a></li>\n    <li class="floatL featured"><a href="feature-items">FEATURED ROW</a></li>\n  </ul>\n  <a class="button buttonFlat buttonPrimary buttonMedium floatR bm">\n    launch a new product\n  </a>\n</div>\n';
}
return __p;
});

M.Template.StorefrontTools.PositionDialog = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<h2>position your items</h2>\n\n<p>\n  Choose the order in which you would like your items to appear.\n</p>\n\n<div class="productPreviewImages">\n  <img width="200" src="https://cdn3.minted.com/files/mintedProductsImages/MIN/GNA/J9N/MIN-J9N-GNA-007_A_CP.jpg">\n  <img width="200" src="https://cdn3.minted.com/files/mintedProductsImages/MIN/GNA/J9N/MIN-J9N-GNA-007_A_CP.jpg">\n  <img width="150" src="https://cdn3.minted.com/files/mintedProductsImages/MIN/GNA/J9N/MIN-J9N-GNA-007_A_CP.jpg">\n</div>\n\n\n<ul class="inline buttons">\n  <li>\n    <a class="button buttonFlat buttonMedium buttonSecondary\n        cancelButton">cancel\n    </a>\n  </li>\n  <li>\n    <a class="button buttonFlat buttonMedium buttonPrimary\n        saveButton">\n        save\n    </a>\n  </li>\n</ul>';
}
return __p;
});

M.Template.StorefrontTools.Product = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n<td>\n  ';
 if (productModel.get('isFeatured') === true) { 
__p+='\n  <img class="sprite featuredActive" data-id="'+
((__t=( productModel.id ))==null?'':__t)+
'"\n      src="'+
((__t=( M.img_src("/static/images/sprite_placeholder.png") ))==null?'':__t)+
'" />\n  ';
 } else { 
__p+='\n  <img class="sprite featuredInactive" data-id="'+
((__t=( productModel.id ))==null?'':__t)+
'"\n      src="'+
((__t=( M.img_src("/static/images/sprite_placeholder.png") ))==null?'':__t)+
'" />\n  ';
 } 
__p+='\n</td>\n';
 if (productModel.get('weight') >= 0) { 
__p+='\n<td>\n  <input\n    class="storefrontInput storefrontToolsInput"\n    type="text"\n    value="'+
((__t=( M.html.htmlAttributeEscape(productModel.get('weight')) ))==null?'':__t)+
'">\n  </input>\n</td>\n';
 } 
__p+='\n<td class="productContainer">\n  <div class="productInfo">\n    <div class="media avatar floatL">\n      <a class="img">\n        <img src="'+
((__t=(productModel.getImgUrl()))==null?'':__t)+
'" />\n      </a>\n    </div>\n    <div class="floatL">\n      <a class="productName">\n        '+
((__t=( M.html.htmlAttributeEscape(productModel.get('name')) ))==null?'':__t)+
'\n      </a>\n  </div>\n</td>\n<td>\n  <div class="productInfo">\n    <span class="productInfoDescription">\n      '+
((__t=( M.html.htmlAttributeEscape(productModel.get('productKindName')) ))==null?'':__t)+
'\n    </span>\n  </div>\n</td>\n<td>\n  ';
 if (productModel.get('isWinner')) { 
__p+='\n    <div class="productInfo">\n      <img class="sprite winnerIcon"\n        src="'+
((__t=( M.img_src("/static/images/sprite_placeholder.png") ))==null?'':__t)+
'"/>\n    </div>\n  ';
 } 
__p+='\n</td>\n\n';
}
return __p;
});

M.Template.StorefrontTools.ProductRow = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n<div class="productCol gridCol floatL">\n  <div class="productImgContainer floatL verticalCenter">\n    ';
 if (isRenderable) { 
__p+='\n      <a class="productImgUrl floatL" \\\n    ';
 } else { 
__p+='\n      <a class="loadingSpinner productImgUrl floatL" \\\n    ';
 } 
__p+='\n      href="'+
((__t=( M.html.htmlAttributeEscape(this.model.getPdpUrl()) ))==null?'':__t)+
'"\n        target="_blank">\n      <img class="productImg"\n        src="'+
((__t=( M.html.htmlAttributeEscape(this.model.get('productImageUrl')) ))==null?'':__t)+
'"\\\n        title="'+
((__t=( M.html.htmlAttributeEscape(this.model.get('name')) ))==null?'':__t)+
'"/>\n    </a>\n  </div>\n  <div class="productDetails floatL verticalCenter">\n    <a class="inline" href="'+
((__t=( M.html.htmlAttributeEscape(this.model.getPdpUrl()) ))==null?'':__t)+
'"\n        target="_blank">\n      '+
((__t=( M.html.htmlAttributeEscape(this.model.get('name')) ))==null?'':__t)+
'\n    </a>\n    <h4>\n      '+
((__t=( M.html.htmlAttributeEscape(this.model.get('productKind')) ))==null?'':__t)+
'\n    </h4>\n    ';
 if (this.model.get('isExclusive')) { 
__p+='\n      <h4>exclusive to minted</h4>\n    ';
 } 
__p+='\n  </div>\n  ';
 if (this.model.get('isWinner')) { 
__p+='\n    <img class="sprite winnerIconMargin winnerIcon floatR"\n      src="/static/images/sprite_placeholder.png"></img>\n  ';
 } 
__p+='\n</div>\n\n<div class="storeSectionCol gridCol floatL">\n  <div class="verticalCenter">\n    ';
 var totalSections = displaySections.length - 1;
      _.each(displaySections, function(section, idx) {
        if ((typeof section['sectionUrl'] === 'undefined') ||
          (section['sectionUrl'] == '')) { 
__p+='\n          <span class="calloutText currentSection">\n            '+
((__t=( M.html.htmlAttributeEscape(
            section['name']) ))==null?'':__t)+
'</span>';
 if (totalSections != idx) { 
__p+=',';
 } 
__p+='\n        ';
 } else { 
__p+='\n        <a href="'+
((__t=( M.html.htmlAttributeEscape(section['sectionUrl']) ))==null?'':__t)+
'">\n          '+
((__t=( M.html.htmlAttributeEscape(
            section['name']) ))==null?'':__t)+
'</a>';
 if (totalSections != idx) { 
__p+=',';
 } 
__p+='\n        ';
 }
      }); 
__p+='\n      ';
 if (numOfLeftoverSections > 0) {  
__p+='\n        + '+
((__t=( M.html.htmlAttributeEscape(numOfLeftoverSections) ))==null?'':__t)+
' more\n      ';
 } 
__p+='\n  </div>\n</div>\n';
 if (hasFeatureLinkColumn) { 
__p+='\n  ';
 if (isAddFeaturedProduct) { 
__p+='\n    <div class="addToFeatureCol gridCol upper floatR">\n      <div class="verticalCenter floatR">\n        ';
 if (isRenderable) { 
__p+='\n          <a class="addToFeatureLink actionLink">\n            feature this product\n          </a>\n        ';
 } 
__p+='\n      </div>\n    </div>\n  ';
 } else { 
__p+='\n    <div class="removeFromFeatureCol gridCol upper floatR">\n      <div class="verticalCenter floatR">\n        ';
 if (isRenderable) { 
__p+='\n          <a class="removeFromFeatureLink actionLink">\n            remove from featured\n          </a>\n        ';
 } 
__p+='\n      </div>\n    </div>\n  ';
 } 
__p+='\n';
 } 
__p+='\n';
 if (hasAddRemoveLinkColumn) { 
__p+='\n  ';
 if (isAddToSection) { 
__p+='\n    <div class="addToSectionCol gridCol upper floatR">\n      <div class="verticalCenter floatR">\n        ';
 if (isRenderable) { 
__p+='\n          <a class="addToSectionLink actionLink">\n            add to section\n          </a>\n        ';
 } 
__p+='\n      </div>\n    </div>\n  ';
 } else { 
__p+='\n    <div class="removeFromSectionCol gridCol upper floatR">\n      <div class="verticalCenter floatR">\n        ';
 if (isRenderable) { 
__p+='\n          <a class="removeFromSectionLink actionLink">\n            remove from section\n          </a>\n        ';
 } 
__p+='\n      </div>\n    </div>\n  ';
 } 
__p+='\n';
 } 
__p+='\n';
}
return __p;
});

M.Template.StorefrontTools.SectionAutoInsertPositionSetting = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n<p>Add new products when they launch to the</p>\n<div class="positionSettingDropdownContainer"></div>\n<p>of this list.</p>\n';
}
return __p;
});

M.Template.StorefrontTools.SectionRow = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n<div class="sectionNameCol gridCol floatL">\n  <div class="verticalCenter truncate">\n    <a class="inline lower"\n      href="'+
((__t=( M.html.htmlAttributeEscape(this.model.get('url_paths')['section_edit_url']) ))==null?'':__t)+
'">\n      '+
((__t=( M.html.htmlAttributeEscape(this.model.get('name')) ))==null?'':__t)+
'\n    </a>\n    <h4 class="inline">'+
((__t=( M.html.htmlAttributeEscape(this.model.get('item_count')) ))==null?'':__t)+
' ';
 if ( this.model.get('item_count') == 1) { 
__p+=' product';
 } else { 
__p+=' products ';
 } 
__p+='</h4>\n  </div>\n</div>\n<div class="statusCol gridCol floatL">\n  <div class="sectionStatusContainer verticalCenter">\n  </div>\n</div>\n';
}
return __p;
});

M.Template.StorefrontTools.SectionStatus = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n\n';
 if (isLoadingSpinner) { 
__p+='\n  <div class="loadingSpinner floatR"></div>\n';
 } else { 
__p+='\n  <h4 class="\n  ';
 if (sectionStatusFloatR) { 
__p+='\n    floatR\n  ';
 } 
__p+='\n  ';
 if (sectionStatusCSS) { 
__p+='\n    '+
((__t=( M.html.htmlAttributeEscape(sectionStatusCSS) ))==null?'':__t)+
'\n  ';
 } 
__p+='\n  ">\n    '+
((__t=( M.html.htmlAttributeEscape(sectionStatus) ))==null?'':__t)+
'\n  </h4>\n';
 } 
__p+='\n';
 if (sectionStatusFloatR) { 
__p+='\n  <br>\n';
 } 
__p+='\n<div class="activityCaption\n';
 if (sectionStatusFloatR) { 
__p+='\n  floatR\n';
 } 
__p+='\n">\n';
 if (isLoadingSpinner) { 
__p+='\n  <span class="spinnerDescription">saving your changes</span>\n';
 } else { 
__p+='\n  '+
((__t=( M.html.htmlAttributeEscape(sectionStatusDetailsHTML) ))==null?'':__t)+
'\n';
 } 
__p+='\n</div>\n';
}
return __p;
});

M.Template.StorefrontTools.SectionVisibility = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n<h4 class="subHeader">\n  '+
((__t=( M.html.htmlAttributeEscape(subHeader) ))==null?'':__t)+
'\n</h4>\n<input type="radio" name="visibility" value="true"\n    '+
((__t=( M.html.htmlAttributeEscape(activeCheckedStr) ))==null?'':__t)+
'\n    '+
((__t=( M.html.htmlAttributeEscape(disabledStr) ))==null?'':__t)+
'>\n  <span class="caption visibilityOption '+
((__t=( M.html.htmlAttributeEscape(
  disabledStr) ))==null?'':__t)+
'">Active</span>\n</input>\n<p class="caption visibilityCaption">\n  '+
((__t=( M.html.htmlAttributeEscape(activeButtonCaption) ))==null?'':__t)+
'\n</p>\n<input type="radio" name="visibility" value="false"\n    '+
((__t=( M.html.htmlAttributeEscape(hiddenCheckedStr) ))==null?'':__t)+
'>\n  <span class="caption visibilityOption">Hidden</span>\n</input>\n<p class="caption visibilityCaption">\n  '+
((__t=( M.html.htmlAttributeEscape(hiddenButtonCaption) ))==null?'':__t)+
'\n</p>\n';
}
return __p;
});

M.Template.StorefrontTools.Wrapper = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<div id="storefrontToolsHeader"></div>\n<div id="storefrontToolsNav"></div>\n<div id="storefrontToolsMain" class="grid_12"></div>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
